import React, { forwardRef, useImperativeHandle } from "react";
import { Product } from "constants/interface/product/product";
import NormalTable from "components/Organisms/tables/normal-table";
import { useGetColumnSearchProps } from "components/Organisms/tables/table-hook";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useListJob, useMerchantsProductTasks } from "./../api";
import { useDebounce } from "../../../utils";
import { useUrlQueryPaging } from "../../../utils/paging";
import { useMerchantsProductsSearchParams } from "./../search-params";
import moment from "moment";

const JobTable = forwardRef((props, ref) => {
  let navigate = useNavigate();

  const [getColumnSearchProps] = useGetColumnSearchProps();

  const [allTask, onChangeAllTask] = useListJob();

  useImperativeHandle(ref, () => ({
    reload() {
      allTask.refetch();
    },
  }));

  const columns: any = [
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      width: 280,
      ...getColumnSearchProps("productName"),
      render: (_: string, record: Product) => {
        return (
          <div>
            <div>
              <Button
                type={`link`}
                style={{ padding: 0 }}
                onClick={() =>
                  navigate(`/project-page/${(record as any).productUUID}`)
                }
              >
                {record.productName}
              </Button>
            </div>
            <span style={{ fontSize: "10px", color: "#8991A0" }}>
              {record.productNumber}
            </span>
          </div>
        );
      },
    },
    {
      title: "Approved Date",
      dataIndex: "approvalDate",
      key: "approvalDate",
      width: 140,
      sorter: (a: { approvalDate: string }, b: { approvalDate: string }) =>
        moment(a.approvalDate, "DD-MM-YYYY").unix() -
        moment(b.approvalDate, "DD-MM-YYYY").unix(),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Task Number",
      dataIndex: "taskNumber",
      key: "taskNumber",
      width: 130,
      sorter: (a: { taskNumber: string }, b: { taskNumber: string }) =>
        a.taskNumber.localeCompare(b.taskNumber),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "ECD",
      dataIndex: "estimatedCompletionDate",
      key: "estimatedCompletionDate",
      width: 130,
      sorter: (
        a: { estimatedCompletionDate: string },
        b: { estimatedCompletionDate: string }
      ) =>
        moment(a.estimatedCompletionDate, "DD-MM-YYYY").unix() -
        moment(b.estimatedCompletionDate, "DD-MM-YYYY").unix(),
      sortDirections: ["descend", "ascend"],
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
      key: "expiryDate",
      width: 130,
      sorter: (a: { expiryDate: string }, b: { expiryDate: string }) =>
        moment(a.expiryDate, "DD-MM-YYYY").unix() -
        moment(b.expiryDate, "DD-MM-YYYY").unix(),
      sortDirections: ["descend", "ascend"],
    },
  ];

  const onChange = (
    pagination: { current: number; pageSize: number },
    filtered: Record<string, any>,
    sorted: Record<string, any>,
    extra: { action: string; currentDataSource: Array<any> }
  ) => {
    onChangeAllTask(pagination, { ...filtered }, sorted, extra);
  };

  return (
    <NormalTable
      scroll={{ x: true }}
      columns={columns}
      loading={allTask.isLoading}
      dataSource={allTask?.data?.list}
      onChange={onChange as any}
      pagination={{
        total: (allTask as any)?.data?.total ?? 0,
      }}
    />
  );
});

export default JobTable;
